module.exports = ".btn-responsive {\n  width: 100%;\n}\n\n@media screen and (min-width: 770px) {\n  .btn-responsive {\n    width: 40%;\n  }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/billing/report-billing-detail/report-billing-detail.component.scss
// module id = ./src/app/system/billing/report-billing-detail/report-billing-detail.component.scss
// module chunks = main